export default __webpack_public_path__ + "static/media/pick.420786c7.png";